import { render, staticRenderFns } from "./ListBubble.vue?vue&type=template&id=1f17dc20&scoped=true&lang=pug&"
import script from "./ListBubble.vue?vue&type=script&lang=ts&"
export * from "./ListBubble.vue?vue&type=script&lang=ts&"
import style0 from "./ListBubble.vue?vue&type=style&index=0&id=1f17dc20&lang=scss&scoped=true&"
import style1 from "./ListBubble.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f17dc20",
  null
  
)

export default component.exports